const UPLOAD_RESULT_NEW_VERSION_SUPPLIER_IDS = [
  '2508',
  '2728',
];

const getLocalStorageItem = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    return '';
  }
};

export const getLoginSupplierId = () => {
  const supplierId = getLocalStorageItem('s_provider_merchantid');
  return supplierId == null ? '' : String(supplierId).trim();
};

export const isUploadResultNewVersionEnabled = (supplierId = getLoginSupplierId()) => {
  const normalizedSupplierId = supplierId == null ? '' : String(supplierId).trim();
  if (!normalizedSupplierId) {
    return false;
  }
  return UPLOAD_RESULT_NEW_VERSION_SUPPLIER_IDS
    .map(id => String(id).trim())
    .includes(normalizedSupplierId);
};
